import React from 'react';
import './GenericError.scss';
import Button from '../../components/Button/Button';
import genericErr from '../../Assets/images/commonImages/generic.svg';
import failedIcon from '../../Assets/images/Activation/failed.svg';

type initialProps = {
    handleGenericErrorCTA?: any;
    isDisabled?: boolean;
};
const GenericError = (props: initialProps) => {
    const { handleGenericErrorCTA, isDisabled } = props;

    return (
        <>
            {isDisabled ? (
                <div className="genericComponentDisabled">
                    <img src={failedIcon} alt="genericErr" />
                    <div className="genericTitle">Something Went Wrong</div>
                    <div className="genericMsg">
                        We're unable to process your request at this moment. Please contact us at{' '}
                        <span>1.800.427.8686</span>
                    </div>
                </div>
            ) : (
                <div className="genericComponent">
                    <img src={genericErr} alt="genericErr" />
                    <div className="genericTitle">Something Went Wrong</div>
                    <div className="genericMsg">
                        We're working on fixing the problem. If you need immediate assistance, please contact us at{' '}
                        <span>1.800.427.8686</span>
                    </div>
                    <div className="genericCTA">
                        <Button onClick={() => handleGenericErrorCTA()} primary={true}>
                            TRY AGAIN
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default GenericError;
